import React from 'react'
import { Box } from '@mui/material'

interface Props {
    header: string | JSX.Element
    content: string | JSX.Element | null
}

const TextBoxOneLine = ({ header, content }: Props) => {
    return (
        <Box sx={{ flexDirection: 'row', display: 'flex', marginTop: '1rem' }}>
            <Box
                sx={{
                    fontWeight: '400',
                    marginRight: '0.5rem',
                    whiteSpace: 'nowrap',
                }}>
                {header}
            </Box>
            {typeof content === 'string' ? (
                <Box sx={{ textAlign: 'center' }}>{content}</Box>
            ) : (
                <>{content}</>
            )}
        </Box>
    )
}
export default TextBoxOneLine
